import { useContext, useEffect, useState } from 'react'
import '../App.css'
import Footer from '../components/Footer'
import Header from '../components/Header'
import Main from '../components/Main'
// import Portifolio from '../components/Portifolio'
import Products from '../components/Products'
import AppContext from '../context/Context'
import { getProperties } from '../services/request'

function Home () {
  const { setLoading } = useContext(AppContext)
  const [searchFilter, setSearchFilter] = useState('')
  const [properties, setProperties] = useState([])
  const [hasMoreProperties, setHasMoreProperties] = useState(true)
  const [propertiesPage, setPropertiesPage] = useState(1)

  const handleProperties = async (page = 1) => {
    setLoading(true)
    try {
      const searchQuery = `${searchFilter}&page=${page}&limit=8`
      const propertiesResult = await getProperties(
        searchQuery)
      setProperties((prev) => [...prev, ...propertiesResult.properties])
      setHasMoreProperties(propertiesResult.hasMore)
    } catch (error) {
      console.error('Error fetching properties:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    handleProperties()
  }, [searchFilter])

  return (
    <div className="App">
      <Header />
      <Main setSearchFilter={setSearchFilter} setProperties={setProperties} />
      {/* <Portifolio /> */}
      <Products
        properties={properties}
        hasMoreProperties={hasMoreProperties}
        setPropertiesPage={setPropertiesPage}
        propertiesPage={propertiesPage}
        handleProperties={handleProperties}
      />
      <Footer />
    </div>
  )
}

export default Home
